import styles from './styles.module.scss';

export type SelectOption = {
    key: any;
    value: any;
    text: string;
    description?: string;
    title?: string;
    extras?: {
        key: string;
        value: any;
    }[];
};

export type SelectType = 'Yes/No';

interface SelectProps extends React.HTMLAttributes<HTMLSelectElement> {
    options?: SelectOption[];
    wrapperClass?: string;
    selectWrapperClass?: string;
    showEmptyOption?: boolean;
    type?: SelectType;
    value: any;
    disabled?: boolean;
}

export const Select = ({
    options,
    wrapperClass,
    selectWrapperClass,
    showEmptyOption,
    type,
    value,
    disabled,
    ...rest
}: SelectProps) => {
    const renderOptions = () => {
        return (
            <>
                <option key='yes' value={1} title='Sim'>
                    Sim
                </option>
                <option key='no' value={0} title='Não'>
                    Não
                </option>
            </>
        );
    };

    const renderSelectOption = (selectOption: SelectOption) => {
        return (
            <option key={selectOption.key} value={selectOption.value} title={selectOption.title}>
                {selectOption.text} {selectOption.description && `(${selectOption.description})`}
            </option>
        );
    };

    return (
        <div className={`${wrapperClass ?? ''} ${styles.wrapper}`}>
            <select
                className={`${selectWrapperClass ?? ''} ${styles.select}`}
                value={value}
                disabled={disabled}
                {...rest}
            >
                {showEmptyOption && <option key='empty' value='' title=''></option>}
                {type ? renderOptions() : options?.map(renderSelectOption)}
            </select>
        </div>
    );
};
